// What the settings search found: the groups it names, then the sections,
// each a way into its address, with the searched words marked.
import { phAttrs } from "../../lib/analytics/attrs.js";
import { ATTRIBUTE } from "../../lib/analytics/surfaceVocabulary.js";
import { searchTerms } from "../../lib/settingsModel.js";
import Highlight from "../ui/Highlight.jsx";

const ROW = "grid w-full cursor-pointer gap-[2px] rounded-[6px] border-0 bg-transparent px-[10px] py-[9px] text-left transition-colors hover:bg-[color-mix(in_srgb,var(--ink)_7%,transparent)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[color:var(--green)]";

function Part({ name, label, children }) {
    return (
        <div className="grid gap-[2px]" data-settings-results={name}>
            <h2 className="m-0 px-[10px] pb-[4px] text-[12.5px] font-medium text-[color:var(--muted)]">{label}</h2>
            <ul className="m-0 grid list-none p-0" aria-label={label}>{children}</ul>
        </div>
    );
}

export default function SettingsResults({ query, hits, groupHits = [], onOpen }) {
    const terms = searchTerms(query);
    if (!hits.length && !groupHits.length) {
        return <p className="m-0 py-[8px] text-[13px] text-[color:var(--muted)]">{`Nothing in Settings matches "${query}".`}</p>;
    }
    return (
        <div className="grid gap-[22px]">
            {groupHits.length ? (
                <Part name="groups" label="Groups">
                    {groupHits.map(({ group, address }) => (
                        <li key={address}>
                            <button type="button" onClick={() => onOpen(address)} {...phAttrs({ [ATTRIBUTE.SETTING]: address })} className={ROW}>
                                <span className="text-[14px] font-medium text-[color:var(--ink)]"><Highlight text={group.name} terms={terms} /></span>
                                <span className="text-[13px] text-[color:var(--muted)]"><Highlight text={group.peek} terms={terms} /></span>
                            </button>
                        </li>
                    ))}
                </Part>
            ) : null}
            {hits.length ? (
                <Part name="settings" label="Settings">
                    {hits.map(({ group, section, address }) => (
                        <li key={address}>
                            <button type="button" onClick={() => onOpen(address)} {...phAttrs({ [ATTRIBUTE.SETTING]: address })} className={ROW}>
                                <span className="text-[14px] font-medium text-[color:var(--ink)]">
                                    <Highlight text={section.name} terms={terms} />
                                    <span className="ml-[10px] text-[12.5px] font-normal text-[color:var(--muted-soft)]"><Highlight text={group.name} terms={terms} /></span>
                                </span>
                                <span className="text-[13px] text-[color:var(--muted)]"><Highlight text={section.peek} terms={terms} /></span>
                            </button>
                        </li>
                    ))}
                </Part>
            ) : null}
        </div>
    );
}
